import React, { Component } from 'react';
import { FormGroup, Button, ButtonToolbar } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';

import '../style/logon.css';
import SMSCode from './SMSCode';
import { getSessionDatas, trackEvent } from '../../../utils'
import MobileInput from './MobileInput';

class logon extends Component {
  constructor() {
    super();
    this.state = {
      count: 120,
      liked: true,
      isPhnFilled: false,
      disableSMSBtn: true,
      disableImageCodeBtn: true,
      sCodeFilled: false,
      phnLength: 11,
      isReceivedVfCode: false
    };
    this.isReSendSMS = false;
    [
      'setTimer',
      'setTimerFlag',
      'handleResent',
      'handleConfirm',
      'handleInputPhnNum',
      'setConfmBtnDisable',
      'setPhnMaxLength',
      'handleSelect',
      'getlabelTxt',
      'handleImageCodeInput'
    ].forEach((fn) => this[fn] = this[fn].bind(this));
  }

  componentWillUnmount = () => {
    this.timer && clearInterval(this.timer);
  }
  componentDidMount() {
    this.handleGetImageCode();
  }
  // 先（图形码验证），  后（发送手机短信）
  handleResent = () => {
    if (!this.isClicked && this.state.liked && !this.state.disableSMSBtn && this.state.isPhnFilled) {
      this.isClicked = true;
      const cCode = this.countrySelect.getValue();
      const countryCode = this.countrySelect.getCountryCode();
      const datas = {
        "countryCode": countryCode,
        "countryNo": cCode,
        "mobile": this.phnNumValue.value,
        "projectId":"RBBOB",
        "codeImage": this.state.handleImageCodeInput, // input图形码
        "imageCodeId": this.state.imageCodeId
      };
      if (this.isReSendSMS) trackEvent('logon');
      this.state.liked && this.props.getOTP(datas, (isSuccess) => {
        if(isSuccess) {
          this.setTimer();
          this.isReSendSMS = true;
          this.setState({ isReceivedVfCode : isSuccess});
        } else {
          this.isClicked = false;
        }
      });
    }
  }
  handleInputPhnNum = (e) => {
    const val = e.target.value;
    const countryCode = this.countrySelect.getCountryCode();
    e.target.value = /[^\d]/.test(val) ? val.replace(/[^\d]/g, '') : val;
    const valInt = parseInt(e.target.value.substring(0, 4), 10);//1700-1719
    if (countryCode === "CN" && valInt >= 1700 && valInt <= 1719) {
      this.props.handleInputError(true, "NetworkNumErr", "moblie");
      this.setState({
        isPhnFilled: false,
        disableSMSBtn: true
      });

    } else {
     // this.refs.smsCode.clearSMSCode();//清空验证码输入框
      this.props.handleInputError(false);
     // this.setTimerFlag(120, true);
      //clearInterval(this.timer);//清除验证码倒计时计时器
      let phnFilled = e.target.value.length === this.state.phnLength;
      this.setState({isPhnFilled: phnFilled});
      this.state.liked && this.setState({disableSMSBtn: !phnFilled});
    }
  }

  handleConfirm = () => {
    const { requestId, guId } = getSessionDatas();
    const cCode = this.countrySelect.getValue();
    const countryCode = this.countrySelect.getCountryCode();
    const datas = {
      "mobile": cCode + this.phnNumValue.value,
      "countryCode": countryCode,
      "verifyCode": this.refs.smsCode.getSMSCode(),
      "requestId": requestId || "",
      "guId": guId || ""
    };
    this.props.verifyOTP(datas);
  }
  setConfmBtnDisable = (sCodeFilled, isClearVfCodeErr) => {
    if(isClearVfCodeErr){
      this.props.handleInputError(false);
    }
    this.setState({
      sCodeFilled: sCodeFilled
    });
  }
  setTimer = (datas) => {
    this.timer = setInterval(function () {
      let count = this.state.count;
      count = count - 1;
      if (count < 1) {
        this.setTimerFlag(120, true);
        this.isClicked = false;
        clearInterval(this.timer);
      } else {
         this.setTimerFlag(count, false);
      }
    }.bind(this), 1000);
  }
  setTimerFlag = (count, liked) => {
    this.setState({
      count: count,
      liked: liked,
      disableSMSBtn: !(this.state.isPhnFilled && liked)
    })
  }
  handleSelect = (countryCode) => {
    const length = this.setPhnMaxLength(countryCode);
    if (this.state.phnLength !== length) {
      this.phnNumValue.value = "";
      this.props.handleInputError(false);
      this.setState({
        isPhnFilled: false,
        disableSMSBtn: true,
        phnLength: length
      });
    }
  }

  setPhnMaxLength = (countryCode) => {
    return countryCode === "CN" ? 11 : 8;
  }
  getlabelTxt = () => {
    const txtObj = {};
    const { logon_i18n } = this.props;
    const { liked, count } = this.state;

    txtObj.timeText = <FormattedMessage
      id={liked ? "logon_i18n.SMSBtnTxt" : "logon_i18n.resendBtnTxt"}
      defaultMessage={liked ? logon_i18n.SMSBtnTxt : logon_i18n.resendBtnTxt}
      values={{ timer: liked ? "" : " ( " + count + "s )" }} />;
    //for assisibility
    txtObj.timer = liked ? "" : <div className="screen-reader-only"><span aria-live="assertive" aria-atomic="true">{logon_i18n.resendBtnforAssisi}</span></div>;
    return txtObj;
  }

  // 获取图片code
  handleGetImageCode = () => {
    const reqDatas = {};
    this.props.getImageCode(reqDatas, (res) => {
      const codeImage = res.respBody.codeImage; // base64 link
      const imageCodeId = res.respBody.imageCodeId; // image code id
      this.setState({ codeImage : codeImage, imageCodeId : imageCodeId });
    });   
  }
  //输入图片code
  handleImageCodeInput = (e)=> {
    const val = e.target.value || e;
    this.setState({ handleImageCodeInput : val });
    const regNum = /^[A-Za-z0-9]+$/; // 只能含有数字有字母
    if (regNum.test(val)) {
      this.props.handleInputError(false);
        if (val.length === 4) {
          this.setState({ disableImageCodeBtn : false }); // 4位 按钮可点击
        } else {
          this.setState({ disableImageCodeBtn : true });
        }
    } else {
      if(val !== "") {
        this.props.handleInputError(true, "imageCodeFormatError", "imageCode"); // 请输入有效的图形验证码
      } else {
        this.props.handleInputError(false);
      }
    }
  }

  render() {
    const { logon_i18n, isDisplayInputErr, inputErrMsg, errLocation } = this.props;
    const { timeText, timer } = this.getlabelTxt();
    const disableConfmBtn = !(!this.props.isDisplayInputErr && this.state.isPhnFilled && this.state.sCodeFilled);
    return (
      <div className="dynamic-form ao-form container" data-id="Logon">
        <div className="logon-container" >
          <div className="logon-main-body">
            <FormGroup className="logon-logonApply-group">
              <h1 data-key={"logon_titleTxt_label"}>{logon_i18n.logonTitle}</h1>
              <div data-key={"logon_plsTxt_label"} className="control-label">{logon_i18n.plsTxt}</div>
            </FormGroup>
            <MobileInput
              i18n={logon_i18n}
              onChangeAction={this.handleSelect}
              handleTextChange={this.handleInputPhnNum}
              maxLength={this.state.phnLength}
              isPhnFilled={this.state.isPhnFilled}
              selectRef={selectValue => this.countrySelect = selectValue}
              phnRef={input => this.phnNumValue = input}
              isDisplayErr={errLocation === "moblie" && isDisplayInputErr}
              inputErrMsg={inputErrMsg}
            />
            <SMSCode
              setConfmBtnDisable={this.setConfmBtnDisable}
              ref="smsCode"
              content={{ "title": logon_i18n.confirmation_code, "SMSBtnTxt": timeText, "imageCodeTitle": logon_i18n.imageCodeTitle }}
              SMSBtnEvt={this.handleResent}
              disableSMSBtn={this.state.disableSMSBtn || this.state.disableImageCodeBtn}
              isDisplayErr={errLocation === "varifyCode" && isDisplayInputErr}
              isDisplayImageCodeErr={errLocation === "imageCode" && isDisplayInputErr}
              timer={timer}
              inputErrMsg={inputErrMsg}
              imageSrc={this.state.codeImage}
              imageCodeInputValue = {this.state.imageCodeInputValue}
              handleGetImageCode = {this.handleGetImageCode}
              handleImageCodeInput={this.handleImageCodeInput}
              disableSMSinput={!this.state.disableSMSBtn || this.state.disableImageCodeBtn}/>
          </div>
          <div className="logon-btn-body">
            <ButtonToolbar>
              <Button
                role="button"
                aria-pressed={false}
                aria-disabled={this.state.isReceivedVfCode ? disableConfmBtn : true}
                data-key={"logon_btn_next"}
                bsStyle="primary"
                onClick={this.handleConfirm}
                disabled={this.state.isReceivedVfCode ? disableConfmBtn : true}>
                {logon_i18n.nextBtn}
              </Button>
            </ButtonToolbar>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(logon);



// WEBPACK FOOTER //
// ./src/views/Logon/components/Logon.js